import { BadgeCheck, Users, Target } from "lucide-react";
import { BRAND } from "@/lib/api";

export default function BrandBanner({ stats }) {
  return (
    <section className="card-surface p-5 lg:p-6 flex items-center gap-4 lg:gap-5 fade-up" data-testid="brand-banner">
      <div className="relative shrink-0">
        <img
          src={BRAND.avatar}
          alt="Bertrand"
          className="w-14 h-14 lg:w-20 lg:h-20 rounded-full object-cover border-2 border-[#1877f240] shadow-lg"
        />
        <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-[#1877F2] border-2 border-[#ffffff] flex items-center justify-center">
          <BadgeCheck className="w-3.5 h-3.5 text-white" fill="currentColor" strokeWidth={0} />
        </div>
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <h1 className="font-display text-xl sm:text-2xl lg:text-3xl font-extrabold tracking-tight">{BRAND.name}</h1>
          <span className="chip chip-fb">Facebook officiel</span>
        </div>
        <p className="text-sm text-[color:var(--bcs-text-mut)] mt-1 max-w-xl leading-relaxed">
          Agent IA de veille des blogueurs africains de la diaspora européenne · potins,
          clashs, rumeurs &amp; buzz des célébrités afro-diaspo transformés en shorts FB/TikTok.
        </p>
      </div>

      <div className="hidden md:flex items-center gap-5 shrink-0">
        <div className="text-right">
          <div className="font-mono-ui text-[10.5px] tracking-widest uppercase text-[color:var(--bcs-text-dim)] flex items-center justify-end gap-1">
            <Users className="w-3 h-3" /> Abonnés
          </div>
          <div className="font-display font-bold text-xl">17 000</div>
        </div>
        <div className="w-px h-10 bg-[#e4e6eb]" />
        <div className="text-right">
          <div className="font-mono-ui text-[10.5px] tracking-widest uppercase text-[color:var(--bcs-text-dim)] flex items-center justify-end gap-1">
            <Target className="w-3 h-3" /> Engagement
          </div>
          <div className="font-display font-bold text-xl text-[color:var(--bcs-success)]">
            +{stats?.engagement_estimate_pct ?? "—"}%
          </div>
        </div>
      </div>
    </section>
  );
}
